import { List } from './list';
import { VisitUiType } from 'store/visits/types';

export const UpcomingVisitorsList = (): JSX.Element => <List type={VisitUiType.UPCOMING} />;
